<div class="content-container">
  <mat-card>
    <!-- Privacy Statement should be included here. The Html  document should have it's own title tag. -->
    <mat-card-title></mat-card-title>
    <mat-card-content>
      <div [innerHtml]="htmlText"></div>
    </mat-card-content>
  </mat-card>
</div>